import React, { useState } from "react";
import { TextField, InputAdornment } from "@mui/material";

interface Props {
  value: number;
  onChange: (value: number) => void;
  fullWidth?: boolean;
  label?: string;
}

function toDisplay(value: number): string {
  if (!value && value !== 0) return "";
  return value.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function formatDisplay(raw: string): string {
  const digits = raw.replace(/\D/g, "");
  if (!digits) return "";
  const cents = parseInt(digits, 10);
  return (cents / 100).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function parseDisplay(display: string): number {
  // "1.000,01" → 1000.01
  return parseFloat(display.replace(/\./g, "").replace(",", ".")) || 0;
}

const BalanceField: React.FC<Props> = ({ value, onChange, fullWidth = true, label = "Saldo" }) => {
  const [display, setDisplay] = useState<string>(value ? toDisplay(value) : "");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatDisplay(e.target.value);
    setDisplay(formatted);
    onChange(parseDisplay(formatted));
  };

  return (
    <TextField
      fullWidth={fullWidth}
      label={label}
      variant="outlined"
      required
      value={display}
      onChange={handleChange}
      slotProps={{
        input: {
          startAdornment: <InputAdornment position="start">R$</InputAdornment>,
          inputMode: "numeric",
        },
      }}
    />
  );
};

export default BalanceField;
